// Google Ads purchase-conversion helper.
// `window.__ADS_PURCHASE_SEND_TO` is populated by AnalyticsScripts from /site-config
// as `AW-XXXXXXXXX/<label>`. Fires the conversion at most once per transaction.
const firedThisSession = new Set();

export function fireAdsPurchase({ transactionId, value, currency = "USD" } = {}) {
  const sendTo = window.__ADS_PURCHASE_SEND_TO;
  if (!sendTo || typeof window.gtag !== "function") return;

  const key = transactionId || "no-txn";
  if (firedThisSession.has(key)) return; // guards React StrictMode + status polling
  const ssKey = `ads_conv_${key}`;
  try {
    if (window.sessionStorage.getItem(ssKey)) { firedThisSession.add(key); return; }
  } catch { /* ignore */ }
  firedThisSession.add(key);

  const payload = { send_to: sendTo };
  if (transactionId) payload.transaction_id = String(transactionId);
  if (value != null && !Number.isNaN(Number(value))) {
    payload.value = Number(value);
    payload.currency = currency;
  }
  window.gtag("event", "conversion", payload);
  try { window.sessionStorage.setItem(ssKey, "1"); } catch { /* ignore */ }
}
